import React from 'react';
import CreateRuleGroupLayout from './UpdateRuleGroupLayout';

const UpdateRuleGroupPage = () => {
    return <CreateRuleGroupLayout />;
};

export default UpdateRuleGroupPage;
